import React, { useState, useEffect, Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import classnames from 'classnames'
import AvatarNew from '~/Common-Objects/UI/Avatar'
import ChatMessageGroup from '~/Common-Objects/UI/Chat/MessageGroup'
import Dialog from '~/Common-Objects/UI/Dialog'
import DropdownMenu from '~/Common-Objects/UI/DropdownMenu'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import SelectNewDefault from '~/Common-Objects/UI/Select/Default'
import UilibIcon from '~/Common-Objects/UI/Icon'
import Composer from './composer'
import ComposerNewChat from './composerNewChat'
import InboxButton from '../../shared/inboxButton'
import axios from '~/data/http/axios'
import ChatHelpers from './helpers/chatHelpers'
import moment from 'moment'
import ConversationsButton from '../../../../components/button'
import i18n from '~/i18n'
import { parseChannelType } from '../../../../../../../Classes/conversations'
import ChangeContact from './changeContact'
import { alterFullpage } from '~/data/actions/siteActions'

export default function InboxCenter({
    className,
    activeConversation = {},
    creatingConversation = null,
    createdConversation = () => {},
    activeInbox = () => {},
    subscriber = {},
    sentMessage = () => {},
    channels = [],
    chatLines = [],
    staff = [],
    doingWizard = false,
    wizardConversation = false,
    loadingChatLines = true,
    visitorTyping = undefined,
    sendAgentTyping = () => {},
    userRole = null,
    reloadConversation = () => {},
    updateConversations = () => {}
}) {
    const history = useHistory()
    const classes = classnames('inbox-center', className)
    const accountUser = useSelector((state) => state.user)
    const dispatch = useDispatch()

    const [firstRun, setFirstRun] = useState(true)
    const [chatLinesFinal, setChatLinesFinal] = useState([])
    const [users, setUsers] = useState([])
    const [assignedTo, setAssignedTo] = useState(activeConversation.AccountUserId || '')

    useEffect(() => {
        axios.get('/accountUser').then((res) => {
            setUsers(res.data.AccountUsers)
        })
        setFirstRun(false)
    }, [])

    useEffect(() => {
        if (users.length) init()
    }, [users])

    useEffect(() => {
        if (!loadingChatLines) {
            init()
        }
    }, [loadingChatLines, chatLines])

    useEffect(() => {
        init()
    }, [visitorTyping])

    const init = () => {
        let chatLinesOut = ChatHelpers.splitConvIntoGroups(chatLines, accountUser, users, subscriber)
        let lastCreatedAt = null
        let lastChannelType = 0
        let outPut = chatLinesOut.map((groupLine, chlIndex) => {
            const firstChatLineId = groupLine.chatLines.length ? groupLine.chatLines[0].id : 0
            let outLine = [
                <ChatMessageGroup
                    status={groupLine.status}
                    isMe={groupLine.isMe || groupLine.isStaff}
                    isAi={groupLine.isAi}
                    name={groupLine.name}
                    avatar={groupLine.avatar}
                    createdAt={groupLine.createdAt}
                    channelType={groupLine.channelType}
                    isStaff={groupLine.isStaff}
                    id={firstChatLineId}
                    key={'clg_' + chlIndex}
                >
                    <div className='chat-message-bubbles'>
                        {groupLine.chatLines.map((chatLine, index) => {
                            const attachments = chatLine.ChatAttachments || []
                            let chatLineOut = ChatHelpers.processChatLine(
                                chatLine,
                                groupLine.isMe || groupLine.isStaff,
                                groupLine.isAi,
                                history,
                                userRole,
                                false,
                                undefined,
                                undefined,
                                accountUser
                            )
                            if (chatLine.type === 4) return chatLineOut
                            if (attachments.length) {
                                return (
                                    <Fragment key={'cl_' + index}>
                                        {!!chatLine.text && <li className='chat-message-parent'>{chatLineOut}</li>}
                                        {attachments.map((a) => {
                                            return (
                                                <li className='chat-message-parent' key={'cl_attachment_' + a.id}>
                                                    {ChatHelpers.processChatLine(
                                                        a,
                                                        groupLine.isMe || groupLine.isStaff,
                                                        groupLine.isAi,
                                                        history,
                                                        userRole,
                                                        true,
                                                        downloadAttachment,
                                                        a,
                                                        accountUser
                                                    )}
                                                </li>
                                            )
                                        })}
                                    </Fragment>
                                )
                            } else {
                                return (
                                    <li className='chat-message-parent' key={'cl_' + index}>
                                        {chatLineOut}
                                    </li>
                                )
                            }
                        })}
                    </div>
                </ChatMessageGroup>
            ]

            if (
                lastCreatedAt != null &&
                moment(lastCreatedAt).format('YYYY-MM-DD') !== moment(groupLine.createdAt).format('YYYY-MM-DD')
            ) {
                let theDateText = moment(groupLine.createdAt).format('dddd, Do MMMM YYYY')
                if (moment(groupLine.createdAt).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
                    theDateText = 'Today'
                }
                outLine.unshift(
                    <div key={'cl_' + chlIndex + '_date'} className='chat-divider chat-divider--date'>
                        {theDateText}
                    </div>
                )
            }
            if (groupLine.chatLines.length === 1 && groupLine.chatLines[0].type == 4) {
                let newStaffId = groupLine.chatLines[0].text
                if (!isNaN(newStaffId)) {
                    newStaffId = Number(newStaffId)
                    const foundStaffMember = staff.find((s) => s.AccountUserId == newStaffId)
                    let foundStaffMemberName = foundStaffMember
                        ? foundStaffMember?.AccountUser?.firstName + ' ' + foundStaffMember?.AccountUser?.lastName
                        : 'Unknown'
                    const foundStaffMemberPicture = foundStaffMember
                        ? foundStaffMember?.AccountUser?.profilePicFileName
                        : ''
                    if (newStaffId === -1) {
                        outLine = [
                            <div className='chat-divider chat-divider--assignee' key={'ot_-1'}>
                                {i18n.t('chat:inbox.conversation.chat.assigneeRemoved')}
                            </div>
                        ]
                    } else {
                        outLine = [
                            <div className='chat-divider chat-divider--assignee' key={'ot_-1'}>
                                {i18n.t('chat:inbox.conversation.chat.assignedTo')}
                                <div className='chat-divider__agent'>
                                    <AvatarNew
                                        size={16}
                                        src={foundStaffMemberPicture}
                                        name={foundStaffMemberName}
                                    />
                                    {foundStaffMemberName}
                                </div>
                            </div>
                        ]
                    }
                }
            } else if (groupLine.chatLines.length === 1 && groupLine.chatLines[0].type === 7) {
                outLine = [
                    <div className='chat-divider chat-divider--assignee' key={'ot_-1'}>
                        {groupLine.chatLines[0].text}
                    </div>
                ]
            } else if (chlIndex > 0 && lastChannelType !== groupLine.channelType) {
                outLine.unshift(
                    <div key={'cl_' + chlIndex + '_channel'} className='chat-divider chat-divider--channel'>
                        {i18n.t('chat:inbox.conversation.chat.channelChanged', {
                            channel: parseChannelType(groupLine.channelType)
                        })}
                    </div>
                )
            }
            lastChannelType = groupLine.channelType
            lastCreatedAt = groupLine.createdAt
            return outLine
        })

        if (visitorTyping) {
            outPut.push(
                <ChatMessageGroup
                    status={0}
                    isMe={false}
                    isAi={false}
                    name={subscriber.emailAddress}
                    createdAt={undefined}
                    channelType={1}
                    key={'vT_1'}
                    style={{ alignItems: 'baseline' }}
                >
                    <LoadingIcons iconType={'3'} />
                </ChatMessageGroup>
            )
        }
        setChatLinesFinal(outPut)
    }

    const closeConversation = async (assignTo) => {
        let postData = {}
        if (assignTo) postData.assignTo = assignTo
        await axios.put(`/inboxes/chat/${activeConversation.id}/close`, postData)
        sentMessage(undefined, true)
    }

    const openConversation = async () => {
        await axios.put(`/inboxes/chat/${activeConversation.id}/open`)
        sentMessage(undefined, true)
    }

    const downloadAttachment = async (location, attachment) => {
        if (!location) location = attachment.location
        if (attachment.type.indexOf('image') === 0 && location) {
            // facebook so show the image in a modal
            const modal = (
                <div className='tpModalRoot'>
                    <div
                        className='tpModalBg tpModalBgBlur'
                        onClick={() => dispatch(alterFullpage(null))}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        onKeyDown={(e) => {
                            // remove on escape press
                            console.log(e.code)
                            if (e.code === 'escape') dispatch(alterFullpage(null))
                        }}
                    >
                        <img src={location} alt={attachment.filename} style={{ maxWidth: '90vw', maxHeight: '90vh' }} />
                    </div>
                </div>
            )
            dispatch(alterFullpage(modal))
        } else if (location.indexOf('https://') === 0 || location.indexOf('http://') === 0) {
            window.open(location, '_blank')
        } else {
            const res = await axios.get(`/inboxes/chat/${activeConversation.id}/attachment/${attachment.id}/download`)
            window.open(res.data.url, '_blank')
        }
    }

    const changeAssignedTo = async (userId) => {
        console.log('changeAssignedTo', userId)
        setAssignedTo(userId || '')
        const isCreatingConversation = creatingConversation && creatingConversation.subscriberId
        try {
            if (!isCreatingConversation) {
                await axios.put(`/inboxes/chat/${activeConversation.id}/assign`, {
                    AccountUserId: userId || null
                })
                updateConversations(true)
            }

            //reloadConversation();
        } catch (e) {
            console.log(e)
        }
    }

    if (loadingChatLines)
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}
            >
                <div style={{ height: '110px' }}>
                    <LoadingIcons />
                </div>
                <div>{i18n.t('chat:inbox.conversation.chat.loading')}</div>
            </div>
        )

    let isCreatingConversation = creatingConversation && creatingConversation.subscriberId

    let activeConversationTypeTxt = activeConversation?.InboxChannel?.name || ''
    if (activeConversation.inboxChannelType === 1) {
        if (activeConversation.subject) {
            activeConversationTypeTxt = `${activeConversation.subject}`
        }
    }

    const assignedToOptions = []
    if (activeConversation.aiEnabled) {
        assignedToOptions.push({ label: i18n.t('chat:inbox.conversation.chat.aiAssigned'), value: -1 })
    }
    assignedToOptions.push({ label: i18n.t('chat:inbox.conversation.chat.unassigned'), value: '' })
    assignedToOptions.push(
        ...staff
            .filter((s) => s.role < 2)
            .map((s) => {
                return {
                    label: (
                        <div className='quickFlex'>
                            <AvatarNew
                                className='mar-r10'
                                src={s.AccountUser.profilePicFileName}
                                name={s.AccountUser.fullname}
                                size={16}
                            />
                            {s.AccountUser.fullname}
                        </div>
                    ),
                    value: s.AccountUserId
                }
            })
    )

    return (
        <main className={classes}>
            <header className='inbox-center__header'>
                <div>
                    <Icon type={activeConversation.inboxChannelType} className='inbox-center__header__icon' />
                </div>
                <div style={{ flex: 1, overflow: 'auto' }}>
                    <h2 style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='inbox-center__header_text'>
                            <div className='inbox-center__header_text_heading'>
                                <div>{subscriber.emailAddress}</div>
                                {activeConversation.inboxChannelType === 1 && !wizardConversation && userRole <= 1 && (
                                    <ChangeContact
                                        activeInbox={activeInbox}
                                        activeConversation={activeConversation}
                                        changedContact={updateConversations}
                                    />
                                )}
                            </div>
                        </div>
                    </h2>

                    <div className='inbox-center__header_text_subHeading'>{activeConversationTypeTxt}</div>
                </div>

                <div className='inbox-center__header__actions'>
                    {!wizardConversation && (
                        <SelectNewDefault
                            disabled={userRole > 1}
                            value={activeConversation.aiEnabled ? -1 : assignedTo}
                            align='end'
                            data={assignedToOptions}
                            triggerProps={{ size: 's' }}
                            onValueChange={(val) => {
                                changeAssignedTo(val)
                            }}
                        />
                    )}
                    {!doingWizard && (
                        <>
                            {activeConversation.status < 2 && (
                                <InboxButton
                                    size='s'
                                    disabled={doingWizard || userRole > 1}
                                    title={doingWizard ? i18n.t('chat:inbox.pleaseAddAChannelFirst') : ''}
                                    variant='secondary'
                                    iconLeft={<UilibIcon name='check' />}
                                    onClick={closeConversation}
                                >
                                    {i18n.t('chat:inbox.conversation.chat.close')}
                                </InboxButton>
                            )}

                            {activeConversation.status === 2 && (
                                <InboxButton
                                    variant='secondary'
                                    size='s'
                                    disabled={doingWizard || userRole > 1}
                                    onClick={openConversation}
                                    aria-label={i18n.t('chat:inbox.conversation.chat.reOpen')}
                                    title={
                                        doingWizard
                                            ? i18n.t('chat:inbox.pleaseAddAChannelFirst')
                                            : i18n.t('chat:inbox.conversation.chat.reOpen')
                                    }
                                >
                                    {i18n.t('chat:inbox.conversation.chat.reOpen')}
                                </InboxButton>
                            )}
                            {userRole <= 1 && (
                                <ConversationOptionsDropdown
                                    conversation={activeConversation}
                                    wizardConversation={wizardConversation}
                                    onChanged={updateConversations}
                                    creatingConversation={creatingConversation}
                                    createdConversation={createdConversation}
                                    doingWizard={doingWizard}
                                    title={doingWizard ? i18n.t('chat:inbox.pleaseAddAChannelFirst') : ''}
                                    alt={doingWizard ? i18n.t('chat:inbox.pleaseAddAChannelFirst') : ''}
                                />
                            )}
                        </>
                    )}
                </div>
            </header>

            <div className='inbox-center__chat-list'>
                <ul className='inbox-center__chat-wrapper faux-list'>{chatLinesFinal}</ul>
            </div>

            <div className='inbox-center__composer-wrapper'>
                {!isCreatingConversation && (
                    <Composer
                        className='inbox-center__composer'
                        activeConversation={activeConversation}
                        sentMessage={sentMessage}
                        staff={staff}
                        doingWizard={doingWizard}
                        wizardConversation={wizardConversation}
                        closeConversation={closeConversation}
                        visitorTyping={visitorTyping}
                        sendAgentTyping={sendAgentTyping}
                        userRole={userRole}
                        reloadConversation={reloadConversation}
                        updateConversations={updateConversations}
                        channels={channels}
                    />
                )}
            </div>

            {isCreatingConversation && (
                <ComposerNewChat
                    className='inbox-center__composer'
                    assignedTo={assignedTo}
                    activeConversation={activeConversation}
                    createdConversation={createdConversation}
                    activeInbox={activeInbox}
                    subscriber={subscriber}
                    channels={channels}
                />
            )}
        </main>
    )
}

function ConversationOptionsDropdown({
    conversation,
    wizardConversation,
    doingWizard,
    onChanged = () => {},
    creatingConversation = {},
    createdConversation = () => {}
}) {
    const [deleting, setDeleting] = useState(false)
    const [working, setWorking] = useState(false)
    const [error, setError] = useState('')

    const onDelete = async () => {
        setWorking(true)
        setError('')

        if (creatingConversation && creatingConversation.subscriberId) {
            createdConversation()
            return
        }

        try {
            await axios.delete(`/inboxes/chat/${conversation.id}`)
            setDeleting(false)
            onChanged(true)
        } catch (e) {
            setError(i18n.t('chat:inbox.conversation.chat.options.error'))
        }
        setWorking(false)
    }

    const onSetSpam = async () => {
        setWorking(true)
        setError('')
        try {
            await axios.put(`/inboxes/chat/${conversation.id}/spam`)
            onChanged(true)
        } catch (e) {
            setError(i18n.t('chat:inbox.conversation.chat.options.error'))
        }
        setWorking(false)
    }
    const onSetNotSpam = async () => {
        setWorking(true)
        setError('')
        try {
            await axios.put(`/inboxes/chat/${conversation.id}/notspam`)
            onChanged(true)
        } catch (e) {
            setError(i18n.t('chat:inbox.conversation.chat.options.error'))
        }
        setWorking(false)
    }

    return (
        <Dialog.Root open={deleting} onOpenChange={setDeleting}>
            <Dialog.Trigger asChild>
                <DropdownMenu.Root>
                    <DropdownMenu.Trigger asChild>
                        <ConversationsButton aria-label='Additional options' variant='ghost' size='s' iconOnly>
                            <UilibIcon name='dots-vertical' />
                        </ConversationsButton>
                    </DropdownMenu.Trigger>

                    <DropdownMenu.Portal>
                        <DropdownMenu.Content align='end'>
                            {conversation.status != 999 &&
                                !wizardConversation &&
                                !creatingConversation?.subscriberId && (
                                    <DropdownMenu.Item onSelect={onSetSpam}>
                                        {i18n.t('chat:inbox.conversation.chat.options.spam')}
                                    </DropdownMenu.Item>
                                )}
                            {conversation.status == 999 &&
                                !wizardConversation &&
                                !creatingConversation?.subscriberId && (
                                    <DropdownMenu.Item onSelect={onSetNotSpam}>
                                        {i18n.t('chat:inbox.conversation.chat.options.notSpam')}
                                    </DropdownMenu.Item>
                                )}
                            {!doingWizard && (
                                <DropdownMenu.Item onSelect={() => setDeleting(true)} variant='danger'>
                                    {i18n.t('chat:inbox.conversation.chat.options.delete')}
                                </DropdownMenu.Item>
                            )}
                        </DropdownMenu.Content>
                    </DropdownMenu.Portal>
                </DropdownMenu.Root>
            </Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay />
                <Dialog.Content className='inbox__generic-modal'>
                    <div className='inbox__generic-modal__header'>
                        {i18n.t('chat:inbox.conversation.chat.options.deleteConfirm')}
                    </div>

                    <div className='inbox__generic-modal__description'>
                        {i18n.t('chat:inbox.conversation.chat.options.deleteDesc')}
                    </div>

                    <div className='inbox__generic-modal__cta'>
                        <InboxButton disabled={working} size='s' variant='danger' onClick={onDelete}>
                            {i18n.t('chat:inbox.conversation.chat.options.deleteButton')}
                        </InboxButton>
                        <InboxButton disabled={working} size='s' variant='secondary' onClick={() => setDeleting(false)}>
                            {i18n.t('chat:inbox.conversation.chat.options.deleteCancel')}
                        </InboxButton>
                    </div>

                    {!!error && <div className='inbox__generic-modal__error'>{error}</div>}
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    )
}

function Icon({ type, ...rest }) {
    let icon

    switch (type) {
        case 1:
            icon = 'mail-open'
            break
        case 2:
            icon = 'chat'
            break
        case 3:
            icon = 'facebook'
            break
        default:
            icon = 'chat'
            break
    }

    return <UilibIcon name={icon} {...rest} />
}
